export const TEST_IDS = {
  modal: 'send-for-approval-modal',
  submitButton: 'send-for-approval-submit-button',
}
